<lib-page-container title="Generate sample" subtitle="Fill information to generate sample QR code"
  [loading]="loading" [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions></div>
  <div lib-page-body>
    <mat-card appearance="outlined" class="left">
      <mat-card-header>
        <mat-card-title>Input data</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="flex-row gap-16">
          <mat-form-field class="flex-1">
            <mat-label>Customer code</mat-label>
            <input type="text" required matInput placeholder=""
              [formControl]="customerCodeControl">
          </mat-form-field>
          <mat-form-field class="flex-1">
            <mat-label>Receipt date</mat-label>
            <input type="text" required matInput placeholder=""
              [formControl]="receiptDateControl">
          </mat-form-field>
          <mat-form-field class="flex-1">
            <mat-label>Invoice number</mat-label>
            <input type="text" required matInput placeholder=""
              [formControl]="invoiceNumberControl">
          </mat-form-field>
          <mat-form-field class="flex-1">
            <mat-label>Total quantity</mat-label>
            <input type="number" required matInput placeholder=""
              [formControl]="totalQuantityControl">
          </mat-form-field>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <lib-button variant="raised" icon="auto_fix_high" (buttonClick)="generate()">Generate</lib-button>
      </mat-card-actions>
    </mat-card>
    @if (responseModel) {
      <mat-card appearance="outlined" class="mt-16">
        <mat-card-header>
          <mat-card-title>Result</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @if (responseModel.errorMessage) {
            <mat-error>{{responseModel.errorMessage}}</mat-error>
          }
          @if (responseModel.sample) {
            <div class="flex-row">
              <div>
                <mat-label>Size: {{qrCodeSizeControl.value}}</mat-label>
                <mat-slider color="primary" min="200" max="600" step="25" thumbLabel>
                  <input matSliderThumb [formControl]="qrCodeSizeControl" />
                </mat-slider>
                <qrcode fxLayout="row" [qrdata]="responseModel.sample" [width]="qrCodeSizeControl.value"
                [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
              </div>
              <div fxLayout="row">
                <pre fxLayout="row" [ngStyle]="{'margin-top': getPreTopMargin()}">{{ getJson(responseModel.sample) | json}}</pre>
              </div>
            </div>
          }
        </mat-card-content>
      </mat-card>
    }
  </div>
</lib-page-container>